export function resetPills() {
  $("#doses_for_pills").prop("selectedIndex", 0);
  $("#doses_for_pills").niceSelect("update");
  $("#wrapper-pills").addClass("d-none");
  $("#hidden-txt").addClass("d-none");
}

export function resetKidneyLiver() {
  $("#weights_for_kidney").prop("selectedIndex", 0);
  $("#weights_for_kidney").niceSelect("update");
  $("#wrapper-kidney-liver").addClass("d-none");
}

export function resetConversion() {
  $("#doses_for_conversion").prop("selectedIndex", 0);
  $("#doses_for_conversion").niceSelect("update");
  $("#wrapper-conversion").addClass("d-none");
}
